// constants/colors.js
export const Colors = {
    // Primary colors (used in both themes)
    primary: {
      main: '#10B981',   // emerald-500
      light: '#34D399',  // emerald-400
      dark: '#059669',   // emerald-600
      faded: '#D1FAE5',  // emerald-100
    },
  
    // Status colors (work in both themes)
    status: {
      success: '#10B981',
      warning: '#F59E0B',
      error:   '#EF4444',
      info:    '#3B82F6',
    },
  
    // Accent colors
    accent: {
      purple: '#A855F7',
      blue:   '#3B82F6',
      orange: '#F97316',
    },
  
    // ── Light theme ──────────────────────────────────────────────
    light: {
      tint: '#10B981',
      primary: {
        main:  '#10B981',
        light: '#34D399',
        dark:  '#059669',
      },
      background: {
        primary:   '#FFFFFF',
        secondary: '#F8FAFC',
        tertiary:  '#F1F5F9',
      },
      text: {
        primary:   '#0F172A',
        secondary: '#475569',
        tertiary:  '#64748B',
        muted:     '#94A3B8',
      },
      border: '#E2E8F0',
      divider: 'rgba(0,0,0,0.08)',
      sidebar: {
        background: '#FFFFFF',
        activeBackground: 'rgba(16, 185, 129, 0.08)',
        hoverBackground:  'rgba(16, 185, 129, 0.05)',
        activeBorder:     '#10B981',
        activeText:       '#10B981',
        text:             '#0F172A',
        icon:             '#475569',
        activeIcon:       '#10B981',
      },
      navbar: {
        background: '#FFFFFF',
        border:     '#E2E8F0',
        icon:       '#10B981',
        searchBg:   '#F1F5F9',
        searchHoverBg: '#E2E8F0',
        searchFocusBg: '#FFFFFF',
      },
      tabBar: {
        background:   '#FFFFFF',
        border:       '#E2E8F0',
        activeIcon:   '#10B981',
        inactiveIcon: '#94A3B8',
      },
    },
  
    // ── Dark theme ───────────────────────────────────────────────
    dark: {
      tint: '#10B981',
      primary: {
        main:  '#10B981',
        light: '#34D399',
        dark:  '#059669',
      },
      background: {
        primary:   '#0A0E1A',  // very dark blue-black (page bg)
        secondary: '#141B2D',  // dark navy (cards / sidebar)
        tertiary:  '#1E2839',  // elevated elements
      },
      text: {
        primary:   '#FFFFFF',
        secondary: '#B8C5D6',
        tertiary:  '#8A99AE',
        muted:     '#6B7A8F',
      },
      border: '#1E2839',
      divider: 'rgba(255,255,255,0.07)',
      sidebar: {
        background:       '#141B2D',
        activeBackground: 'rgba(16, 185, 129, 0.12)',
        hoverBackground:  'rgba(16, 185, 129, 0.07)',
        activeBorder:     '#10B981',
        activeText:       '#10B981',
        text:             '#B8C5D6',
        icon:             '#8A99AE',
        activeIcon:       '#10B981',
      },
      navbar: {
        background: '#141B2D',
        border:     '#1E2839',
        icon:       '#10B981',
        searchBg:   '#1E2839',
        searchHoverBg: '#243044',
        searchFocusBg: '#243044',
      },
      tabBar: {
        background:   '#0A0E1A',
        border:       '#1E2839',
        activeIcon:   '#10B981',
        inactiveIcon: '#6B7A8F',
      },
    },
  };
